import { render, staticRenderFns } from "./ComponentAdminReportNursery72.vue?vue&type=template&id=d9b83628&scoped=true"
import script from "./ComponentAdminReportNursery72.vue?vue&type=script&lang=js"
export * from "./ComponentAdminReportNursery72.vue?vue&type=script&lang=js"
import style0 from "./ComponentAdminReportNursery72.vue?vue&type=style&index=0&id=d9b83628&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b83628",
  null
  
)

export default component.exports